import { useState } from "react";
import CheckBox from "../../../../../../Components/CheckBox/CheckBox";
import ModalWindow from "../../../../../../Components/ModalWindow/ModalWindow";
import ApiPermissions from "../../../../../../Services/Permissions/Data/ApiPermissions";
import { CheckPermissionForEdit } from "../../../../../../Services/Permissions/PermissionManager";
import { AddToastNotification } from "../../../../../../Services/ToastNotification/ToastNotificationManager";
import ApiKeyRequests from "../../../../../../Services/Api/ApiKeyRequests.ts";

const AddEditApiKey = ({editData, hide}) => {
    const apiKeyRequest = new ApiKeyRequests();
    
    const [name, setName] = useState(editData ? editData.name : "");
    const [permission, setPermission] = useState(editData ? editData.permissions : 0);

    const addEdit = () => {
        if(name) 
        {
            if(editData)
                edit();
            else
                add();
        }else{
            AddToastNotification("Klucz musi mieć nazwę", 0);
        }
    }

    const add = () => {
        const data = {
            name : name,
            permission: permission,
        }

        apiKeyRequest.Add(data, () => {
            AddToastNotification("Dodano klucz API", 1);
            hide();
        });
    } 

    const edit = () => {
        const data = {
            id : editData.id,
            name : name,
            permission: permission,
        }

        apiKeyRequest.edit(data, () => {
            AddToastNotification("Edytywano klucz API", 1);
            hide();
        });
    } 

    return (
        <ModalWindow 
            title={editData ? "Edytuj Klucz API" : "Dodaj Klucz API"}
            minWidth={"35%"}
            content={
                <>
                    <div className="modalField">
                        <label>Name</label>
                        <input value={name} onChange={(e) => setName(e.target.value)} className="input w-100p"/>
                    </div>
                    <div>
                        <label>Permissions</label>
                        <div className="columns-2 mb-20">
                            { Object.values(ApiPermissions).filter(x => !x.hidden).map(permissionData => 
                                <CheckBox 
                                    value={CheckPermissionForEdit(permission, permissionData.value)} 
                                    text={permissionData.text} 
                                    onChange={() => {
                                        if(CheckPermissionForEdit(permission, permissionData.value))
                                            setPermission(permission - permissionData.value)
                                        else
                                            setPermission(permission | permissionData.value)
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </>
            }
            buttons={[
                { Text: editData ? "Edytuj" : "Dodaj", onClick: () => addEdit() }, 
                { Text: "Anuluj", onClick: () => hide(), className: "modalSecondaryBtn" }, 
            ]}
        />
    )
}

export default AddEditApiKey;